import React from 'react';
import { Button } from 'framework-ui-components/Components/V2';
import PrintIcon from 'framework-ui-components/Components/GoogleIcons/Outlined/PrintIcon';
import InfoAzioneDisabilitata from './infoAzioneDisabilitata';

const StampaDichiarazioni = ({ primary = false, dichiarazioniSelezionate = [], avviaStampa }) => {
  const nessunaSelezione = dichiarazioniSelezionate.length === 0;

  return (primary ? !nessunaSelezione : nessunaSelezione) && (
    <Button primary={primary} disabled={nessunaSelezione} onClick={() => avviaStampa(dichiarazioniSelezionate.map((x) => x.IdDichiarazione))}>
      {primary && <PrintIcon />}
      Stampa
      {nessunaSelezione && <InfoAzioneDisabilitata />}
    </Button>
  );
};

export default StampaDichiarazioni;
